import { Box, Dialog, Grid } from "@mui/material";
import { useEffect, useState } from "react";


import * as yup from "yup";
import { Field, Form, Formik } from "formik";
import { string } from "yup";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { Client, EditClientCommand } from "../../../api/models/schema";
import { StandardTextBox } from "../../../common/standardTextBox";

export interface FormValues {
  name: string;
}

const validationSchema = yup.object({
  name: string().min(5, "too short").required("required"),
});

export interface EditClientFormProps {
  client: Client | undefined;
  userName?: string;
  open: boolean;
  onClose: () => void;
  onUpdate: (client: EditClientCommand) => void;
}

export function AddClientForm(props: EditClientFormProps) {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  function update(values: FormValues) {
    const updateClient: EditClientCommand = {
      name: values.name,
    };

    setIsLoading(true);
    props.onUpdate(updateClient);
    setIsLoading(false);
  }
  useEffect(() => {
    if (props.open) {
      setIsLoading(false);
    }
  }, [props.open]);

  function handleClose() {
    props.onClose();
  }

  function displayForm() {
    return (
      <Box>
        <Dialog open={props.open}>
          <DialogTitle>Add Client</DialogTitle>
          <DialogContent>
            <Formik
              initialValues={
                props.client
                  ? {
                      name: props.client.name,
                    }
                  : {
                      name: "",
                    }
              }
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                update(values);
              }}
            >
              {({ submitForm, isSubmitting }) => (
                <Form>
                  <br />

                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      Client Name
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="name"
                        label="Client Name"
                        width={375}
                      />
                    </Grid>

                    <Grid
                      spacing={2}
                      item
                      container
                      xs={12}
                      justifyContent="flex-end"
                    >
                      {!isLoading && (
                        <Grid item>
                          <Button variant="contained" onClick={submitForm}>
                            Save
                          </Button>
                        </Grid>
                      )}
                      {isLoading && (
                        <Grid item>
                          <CircularProgress />
                        </Grid>
                      )}
                      <Grid item>
                        <Button onClick={handleClose}>Cancel</Button>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      {errorMessage && <p>errorMessage</p>}
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </Box>
    );
  }

  return <>{displayForm()}</>;
}
